const actionTypes = {
  Initialize: 'INITIALIZE',
};

export default actionTypes;
